export default __webpack_public_path__ + "static/飞书20210918-142421-85993d675ca82c21d7be98f48ebdf01f.png";